module.exports = __webpack_public_path__ + "static/stacked-bar-fc9abde75c2b9016cfe537d1ec0bee63.png";